import React from 'react';
import { Container } from '../components/Container';
import { Label } from '../components/Label';
import { Button } from '../components/Button';
export function ContactPage() {
  return <div className="flex-grow flex flex-col" data-id="element-260" data-mp="sqj7nwjwjomi">
      <section className="border-b border-brand-gray300 py-[clamp(70px,10vw,140px)] flex-grow" data-id="element-261" data-mp="sqsw3fpatnq3">
        <Container data-id="element-262" data-mp="xoufy2ujtr2m">
          <div className="grid gap-12 md:grid-cols-[minmax(170px,0.65fr)_minmax(0,1.35fr)] md:gap-16" data-id="element-263" data-mp="xrgkdtm57qgm">
            <div data-id="element-264" data-mp="11g12a4jm26p">
              <Label data-id="element-265" data-mp="50f2hkr2fgte">Contact</Label>
              <h1 className="mt-5 text-[clamp(3.6rem,9vw,6rem)] font-black leading-[0.86] tracking-[-0.05em]" data-id="element-266" data-mp="51q4pg4v4gie">
                Say Hello.
              </h1>
              <p className="mt-6 max-w-[40ch] text-[clamp(16px,1.4vw,19px)] leading-[1.5] text-[#2a2a2a]" data-id="element-267" data-mp="eyuvxudkf262">
                Please fill out the form below to request a quote for a project, inquire about a collaboration, or simply say hello.
              </p>
            </div>

            <form className="flex flex-col gap-6" onSubmit={e => e.preventDefault()} data-id="element-268" data-mp="1qg4duch1pm59">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-269" data-mp="qzvn4jcfi5wk">
                <div className="flex flex-col gap-2" data-id="element-270" data-mp="n04ra181ozl6">
                  <label htmlFor="firstName" className="font-bold text-[14px]" data-id="element-271" data-mp="i007a17xhmq7">First Name (required)</label>
                  <input type="text" id="firstName" required className="border-2 border-brand-black p-4 focus:outline-none focus:border-brand-accent transition-colors" data-id="element-272" data-mp="d0vwj65cvgxr" />
                </div>
                <div className="flex flex-col gap-2" data-id="element-273" data-mp="3vewjvb09hu33">
                  <label htmlFor="lastName" className="font-bold text-[14px]" data-id="element-274" data-mp="3vfenisp97al1">Last Name (required)</label>
                  <input type="text" id="lastName" required className="border-2 border-brand-black p-4 focus:outline-none focus:border-brand-accent transition-colors" data-id="element-275" data-mp="3qhd6edbe1lc7" />
                </div>
              </div>
              
              <div className="flex flex-col gap-2" data-id="element-276" data-mp="36wcvvxf3urm0">
                <label htmlFor="email" className="font-bold text-[14px]" data-id="element-277" data-mp="3bu4rb1eykvuy">Email (required)</label>
                <input type="email" id="email" required className="border-2 border-brand-black p-4 focus:outline-none focus:border-brand-accent transition-colors" data-id="element-278" data-mp="2xudf96805pjl" />
              </div>
              
              <div className="flex flex-col gap-2" data-id="element-279" data-mp="3uijefdm5npqh">
                <label htmlFor="subject" className="font-bold text-[14px]" data-id="element-280" data-mp="3ulfb6ym9o8dc">Subject (required)</label>
                <input type="text" id="subject" required className="border-2 border-brand-black p-4 focus:outline-none focus:border-brand-accent transition-colors" data-id="element-281" data-mp="3gqd8ekcpuz4r" />
              </div>
              
              <div className="flex flex-col gap-2" data-id="element-282" data-mp="h6j1pxp8ch4o">
                <label htmlFor="message" className="font-bold text-[14px]" data-id="element-283" data-mp="21u1z7ncomy5r">Message (required)</label>
                <textarea id="message" required rows={5} className="border-2 border-brand-black p-4 focus:outline-none focus:border-brand-accent transition-colors resize-y" data-id="element-284" data-mp="1wuz5v062egdm"></textarea>
              </div>
              
              <div className="mt-4" data-id="element-285" data-mp="1ix0tu1f7uw1a">
                <Button variant="solid" className="w-full sm:w-auto" data-id="element-286" data-mp="1iy2d2t6dyou3">Submit</Button>
              </div>
            </form>
          </div>
        </Container>
      </section>
    </div>;
}